<template>  
  <v-layout class="drawer-container" column >
    <v-toolbar class="header-list white" dense @click.stop.prevent="$store.myActions.UI_SET_MEASURETOOL('NONE');" >
      <div  class="flex-grow-0" style="border:1px solid #ccc;border-bottom: 0px;border-top: 0px;border-left:0px ;">        
        <v-btn v-if="!allFleetVisibility" class="mx-0" icon @click.prevent="$store.myActions.UI_SHOW_ALL_DRAWER_MISSION_MAP('');" :title="$t('Pilot.MissionDrawer.ShowAllListedMissionTooltip')" ><v-icon>mdi-eye-off</v-icon></v-btn>  
        <v-btn v-if="allFleetVisibility" class="mx-0" icon @click.prevent="$store.myActions.UI_HIDE_ALL_DRAWER_MISSION_MAP('');" :title="$t('Pilot.MissionDrawer.HideAllListedMissionTooltip')" ><v-icon>mdi-eye</v-icon></v-btn>  
      </div>
      <v-menu offset-y  >
        <v-btn slot="activator" class="text-none" flat ><v-icon class="mr-1" size="18" v-text="ongoingMissionActive?'mdi-timer-outline':'mdi-archive'" /> <span class="text-lowercase">{{ongoingMissionActive?$t('Pilot.MissionDrawer.OnGoing'):$t('Pilot.MissionDrawer.Old')}}</span> <v-icon class="ml-2">mdi-chevron-down</v-icon></v-btn>
        <v-list>                
          <v-list-tile :class="{'primary white--text':!simulatedMissionActive && ongoingMissionActive}" @click="$store.myActions.UI_UNACTIVE_SIMULATED_MISSION_VIEW();$store.myActions.UI_ACTIVE_ONGOING_MISSION_VIEW()">             
            <v-list-tile-title><v-icon class="mr-1" size="18" :class="{'white--text':!simulatedMissionActive && ongoingMissionActive }" >mdi-timer-outline</v-icon> <span class="text-lowercase">{{$t('Pilot.MissionDrawer.OnGoing')}}</span></v-list-tile-title>            
          </v-list-tile>
          <v-list-tile :class="{'primary white--text':!simulatedMissionActive && !ongoingMissionActive}" @click="$store.myActions.UI_UNACTIVE_SIMULATED_MISSION_VIEW();showFinishedMission()">             
            <v-list-tile-title ><v-icon class="mr-1" size="18" :class="{'white--text':!simulatedMissionActive && !ongoingMissionActive}" >mdi-archive</v-icon> <span class="text-lowercase">{{$t('Pilot.MissionDrawer.Old')}}</span></v-list-tile-title>            
          </v-list-tile>
          <!-- <v-list-tile :class="{'primary white--text':simulatedMissionActive && ongoingMissionActive}"  @click="$store.myActions.UI_ACTIVE_SIMULATED_MISSION_VIEW();$store.myActions.UI_ACTIVE_ONGOING_MISSION_VIEW()">             
            <v-list-tile-title><v-icon class="mr-2" :class="{'white--text':simulatedMissionActive && ongoingMissionActive}">mdi-laptop</v-icon> {{$t('Pilot.MissionDrawer.Simulated')}} (<v-icon class="mr-1" :class="{'white--text':simulatedMissionActive && ongoingMissionActive}" size="18" >mdi-timer-outline</v-icon> <span class="text-lowercase">{{$t('Pilot.MissionDrawer.OnGoing')}}</span>)</v-list-tile-title>            
          </v-list-tile>
          <v-list-tile :class="{'primary white--text':simulatedMissionActive && !ongoingMissionActive}" @click="$store.myActions.UI_ACTIVE_SIMULATED_MISSION_VIEW();showFinishedMission()">             
            <v-list-tile-title ><v-icon class="mr-2" :class="{'white--text':simulatedMissionActive && !ongoingMissionActive}">mdi-laptop</v-icon> {{$t('Pilot.MissionDrawer.Simulated')}} (<v-icon class="mr-1" :class="{'white--text':simulatedMissionActive && !ongoingMissionActive}" size="18" >mdi-archive</v-icon> <span class="text-lowercase">{{$t('Pilot.MissionDrawer.Old')}}</span>)</v-list-tile-title>            
          </v-list-tile> -->
        </v-list>  
      </v-menu>
      <!-- <mission-operator-filter  /> -->
      <v-spacer />
      <!-- BLF037 : pas de création sans type autorisé dans l'enseigne cible (RG-ACC-052) -->
      <v-btn v-if="canAddFleet" class="mx-0 " icon @click.prevent="addNewFleet()" :title="$t('Pilot.Fleet.Add')" ><v-icon>mdi-plus</v-icon></v-btn>    
    </v-toolbar>    
    <v-progress-linear v-if="(missionsPassedLoading && !ongoingMissionActive) || (missionsOngoingLoading && ongoingMissionActive)" indeterminate class="my-0"></v-progress-linear>    
    <div ref="liste" class="liste" :style="{overflow:filteredFleet.length <= 24?'auto':'none'}">
      <auto-virtual-scroll-list 
        v-if="filteredFleet.length > 24" 
        v-resize="onResize" :totalHeight="height"
        :defaultHeight="36"
        :extra-items="5"
        style="width: 100%;">            
        <fleet-line :fleet="fleet" v-for="fleet in filteredFleet" :key="fleet.FLE_ID"  />        
      </auto-virtual-scroll-list>
      <div v-else >
        <fleet-line :fleet="fleet" v-for="fleet in filteredFleet" :key="fleet.FLE_ID"  />        
      </div>
    </div>
    <v-dialog
        v-model="showAddFleet"        
        persistent
        close
        scrollable            
        :width="700">
        <v-card  >
          <v-card-text>
            <FleetNew v-if="showAddFleet"/>             
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn small @click="showAddFleet = false" >Close</v-btn>          
            <v-btn small @click="saveFleet()" color="primary" >Save <v-icon class="ml-2" small>mdi-content-save</v-icon></v-btn>          
        </v-card-actions>
        </v-card>
    </v-dialog> 
  </v-layout>
</template>
<script setup lang="ts">
  import { ref, computed, onMounted } from 'vue'
  import FleetLine from '@/components/fleet/FleetLine.vue'  
  import FleetNew from '@/components/fleet/FleetNew.vue'  
  import MissionFilter from '@/components/mission/MissionFilter.vue'  
  import MissionOperatorFilter from '@/components/mission/MissionOperatorFilter.vue'  
  import MissionFilterIcon from '@/components/mission/MissionFilterIcon.vue'   
  import { buildMissionUIStateId } from '@/models/ui/MissionUiState'
  import { router } from '@/mainjs.js'
  import store from '@/store';
  import { AloDbFleet } from '@/models/alodb/AloDbFleet'

  const height = ref(100)
  const liste = ref<HTMLElement>()

  const showAddFleet = ref(false)

  // Computed properties from store getters
  const drawerMissions = computed(() => store.myGetters.drawerMissions)
  const ongoingMissionActive = computed(() => store.myGetters.ongoingMissionActive)
  const simulatedMissionActive = computed(() => store.myGetters.simulatedMissionActive)
  const missionsOngoingLoading = computed(() => store.myGetters.missionsOngoingLoading)
  const missionsPassedLoading = computed(() => store.myGetters.missionsPassedLoading)
  const missionsPassedLoaded = computed(() => store.myGetters.missionsPassedLoaded)
  const allFleetVisibility = computed(() => store.myGetters.allFleetVisibility)
  const filteredFleet = computed(() => store.myGetters.filteredFleet)
  const canAddFleet = computed(() => store.myGetters.creationFleetTypes.length > 0)


  onMounted(() => {
    onResize()
  })

  function onResize() {
    if (liste.value) {
      height.value = liste.value.clientHeight
    }
  }

  function onContextMenu() {
    alert("ok")
  }

  function showFinishedMission() {
    store.myActions.UI_UNACTIVE_ONGOING_MISSION_VIEW()
  }

  async function addNewFleet() {
    await store.myActions.ADMINFLEET_SELECT_DETAIL(-1);
    showAddFleet.value = true
  }

  async function saveFleet() {
    const result = await store.myActions.ADMINFLEET_SAVE_REQUEST() as AloDbFleet
    showAddFleet.value = false    
    if((result?.id ??0) > 0)
    {      
      router.push({name:'FleetDetail',params:{fleetid:result.id!.toString()}})      
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scope>  
  .header-list{
    flex: 0 0 auto;
  }
  .filter{
    flex: 0 0 auto;    
    height: min-content;
    background-color: #eee;
  }
 .liste {
    flex: 1 1 auto;
    overflow: hidden;
    height: min-content;
  }
  
</style>

<style>
  .header-list > .v-toolbar__content{
    padding: 0px;
    display: flex;    
  }
  
</style>

<style scoped>
  button.v-btn--active {
    background-color: var(--primary-color);
    color:white;
  }
</style> 
